import React from 'react';
import PropTypes from 'prop-types';

const AgentEscalation = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
    >
      <path
        d="M1.06551 14.6325C1.11929 15.5142 1.83797 16.1826 2.67061 16.1261C3.50324 16.0694 4.13452 15.3081 4.08074 14.4267L3.99032 12.9432C4.92413 15.8823 7.5454 18 10.6356 18C13.7258 18 16.3469 15.8825 17.2809 12.9437L17.1904 14.4269C17.1368 15.3083 17.7683 16.0695 18.6006 16.1263C19.4334 16.1827 20.1517 15.5144 20.2055 14.6326L20.6326 7.62219C20.686 6.74008 20.0549 5.97953 19.2223 5.92275C18.8824 5.89926 18.5628 5.99858 18.2992 6.1819C17.2155 2.59098 14.2008 0 10.6593 0C7.10807 0 4.0878 2.60398 3.0118 6.2086C2.74053 6.00748 2.40539 5.89784 2.04907 5.92258C1.21627 5.97953 0.585156 6.74061 0.63894 7.62201L1.06551 14.6325ZM10.6591 1.04337C14.0957 1.04337 16.9684 3.84527 17.6098 7.5485L17.5135 9.1278C16.8778 5.71967 14.0409 3.14898 10.6358 3.14898C7.23077 3.14898 4.39353 5.71949 3.75804 9.12797L3.67501 7.76707C4.2389 3.95598 7.15547 1.04337 10.6591 1.04337Z"
        fill={color}
      />
    </svg>
  );
};

AgentEscalation.propTypes = {
  color: PropTypes.string,
};

export default AgentEscalation;
